const QR_TAG_FEATURE_TEAM_IDS: number[] = [368, 632]

type MinimalGroup = Partial<IGroup> & {
  qr_tag_enabled?: boolean
  qr_tags_enabled?: boolean
  qr_tags_count?: number
  has_qr_tags?: boolean
}

export const isQrTagEnabledGroup = (group?: MinimalGroup | null): boolean => {
  if (!group) return false

  const flagEnabled = Boolean(group.qr_tag_enabled ?? group.qr_tags_enabled ?? group.has_qr_tags)
  const countProvided = typeof group.qr_tags_count === 'number'

  return flagEnabled || countProvided
}

export const teamHasQrTags = (team?: { id?: number | null, groups?: IGroup[] | null } | null): boolean => {
  if (!team) return false

  if (isQrTagEnabledGroup(team as unknown as MinimalGroup)) return true
  if (team.groups && team.groups.some((group) => isQrTagEnabledGroup(group))) return true

  return Boolean(team.id && QR_TAG_FEATURE_TEAM_IDS.includes(team.id))
}

export const pickQrTagEnabledGroups = (groups?: IGroup[] | null): IGroup[] => {
  if (!groups) return []

  const enabledGroups = groups.filter((group) => isQrTagEnabledGroup(group))
  if (enabledGroups.length > 0) return enabledGroups

  return groups
}

export default teamHasQrTags
